import React, { Component } from "react";
import ReactDOM from "react-dom";
import butter from "./butter-client";

import parse from 'html-react-parser';
// import ReactHtmlParser from 'react-html-parser';

// import { Pagination } from "antd";
import { CaretLeftOutlined } from '@ant-design/icons';
import { Container, Row, Col, Image } from "react-bootstrap";
import { FadeLoad } from "../styled/Motion.styled";

import './BlogStyle.css';

import { HoverCardBorderLink } from "../styled/BPSCards";
import { Arrow, BPSArrowLink } from "../styled/Buttons";

export class BlogContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minValue: 0,
      maxValue: 4,
      blogPosts: [],
      blogBody: {},
      showBlog: false,
      blogBodyContent: '',
      blogBodyTitle: '',
      blogBodyPublished: '',
      blogBodyImg: '',
      data: []
    };
    this.handleClick = this.handleClick.bind(this);
    this.showPosts = this.showPosts.bind(this);
  }

  componentDidMount() {
    let blogPosts = this.state.blogPosts;
    let currentComponent = this;
    butter.post.list({ page: 1, page_size: 20 }).then(function (response) {
      console.log(response)
      /*
      response.map(blogItem => {
      
      })
      */
      console.log(response.data.data);
      blogPosts = response.data.data
      let data = [];
      const perRow = 2;
      //let rows = parseInt(this.state.blogPosts.length/perRow) + (this.state.blogPosts.length % perRow > 0) ? 1 : 0;
      let colCtr = 0; let tmpList = []; let blogBody = {}; let blogContent = [];
      blogPosts.map(blogItem => {
        let dateTime = new Date(blogItem.published).toISOString().replace(/T/, ' ').replace(/\..+/, '');
        const dateParts = dateTime.split('');
        let blog = {
          title: blogItem.title, value: blogItem.summary, featured_image: blogItem.featured_image
          // , published: moment(dateTime).format('MMMM YYYY')
        };
        blogBody[blogItem.title] = {
          body: blogItem.body, title: blogItem.title, featured_image: blogItem.featured_image
          // published: moment(dateTime).format('MMMM YYYY')
        };
        if (colCtr < perRow) {
          tmpList.push(blog);
          colCtr++;
        } else {
          data.push(tmpList);
          tmpList = [];
          tmpList.push(blog);
          colCtr = 1
        }
      })

      if (tmpList.length > 0) {
        data.push(tmpList);
      }
      //console.log(data);
      currentComponent.setState({ blogPosts, maxValue: blogPosts.length, data, blogBody });
    })
  }

  handleChange = value => {
    if (value <= 1) {
      this.setState({
        minValue: 0,
        maxValue: 9
      });
    } else {
      this.setState({
        minValue: this.state.maxValue,
        maxValue: value * 9
      });
    }
  };

  handleClick = (e, title) => {
    console.log(title);
    let blogBodyContent = this.state.blogBody[title]['body'];
    let blogBodyTitle = title;
    let blogBodyPublished = this.state.blogBody[title]['published'];
    let blogBodyImg = this.state.blogBody[title]['featured_image'];
    this.setState({ showBlog: true, blogBodyContent, blogBodyTitle, blogBodyPublished, blogBodyImg });
  }

  showPosts = () => {
    this.setState({ showBlog: false, blogBodyContent: '' });
  }

  render() {

    return (
      <Container fluid id="top">
        {this.state.showBlog ?
          <section>
            <Container>
              <Image src={this.state.blogBodyImg} className="blog-post-img" />
              <a onClick={this.showPosts} href="#top" className="align-middle"><CaretLeftOutlined className="fs-6 align-middle" /> Back To Posts</a>
              <Row className="py-5 justify-content-center">
                <Col lg={12}>
                  <h1 className="pb-4">{this.state.blogBodyTitle}</h1>
                  {parse(this.state.blogBodyContent)}
                  <p className="border-top border-bottom py-5">
                    Ready to take the next step? At Best Payment Solutions, we understand the impact an improvement to your sales cycle can make on your company's financials. Our experienced team can help your business evaluate its processes and implement a channel partner automation program to meet its unique needs. If you're ready to take your business to a whole new level and get your sales process functioning at peak efficiency when you need it most, then a channel partner incentive program may be the right solution for you. <a href="/schedule-demo" className="bps-link-button ">Click here</a> to schedule a consultation, or give us a call at 800-371-6801.
                  </p>
                  <a onClick={this.showPosts} href="#top" className="align-middle"><CaretLeftOutlined className="fs-6 align-middle" /> Back To Posts</a>
                </Col>
              </Row>
            </Container>
          </section>
          :

          <section>
            <Container fluid className='vh-50 bg-cream'>
              <Row>
                <Col className='text-center'>
                  <FadeLoad>
                    <h2 className='fw-bold fs-24 color-sky-tint-1'>Best Payment Solutions'</h2>
                    <h2 className='fs-48'>
                      Knowledge Center
                    </h2>
                    <p>
                      Information and insight about incentive programs and how they work.
                    </p>
                  </FadeLoad>
                </Col>
              </Row>
            </Container>
            <Container fluid>
              <Row className="justify-content-center pb-5">
                <Col lg={8} sm={12}>
                  {this.state.data &&
                    this.state.data.length > 0 &&
                    this.state.data.map(val => (
                      <Row className="py-2">
                        {val.map(rowItem => (
                          <Col md={6} className="py-2">
                            <a href="#top" >
                              <HoverCardBorderLink
                                onClick={(e) => this.handleClick(e, rowItem.title)}
                              >
                                <Image fluid src={rowItem.featured_image} />
                                <h4 className="pt-4">{rowItem.title}</h4>
                                <p className="bps-midnight-tint">{rowItem.published}</p>
                                <p>{rowItem.value}</p>
                                <BPSArrowLink>Read Article <Arrow /></BPSArrowLink>
                              </HoverCardBorderLink>
                            </a>
                          </Col>
                        ))
                        }
                      </Row>
                    ))}
                </Col>
              </Row>
              {/* <Row className="py-5 text-center">
                        <Col>
                            <Pagination
                            defaultCurrent={1}
                            defaultPageSize={4}
                            onChange={this.handleChange}
                            total={this.state.maxValue}
                            />
                        </Col>
                    </Row> */}
            </Container>
          </section>
        }
      </Container>
    );
  }
}

export default BlogContent;
